<vpfa-customer-data-mobile
  [modalTitleCode]="modalTitleCode"
  [show]="true"
  [isProcessing]="createCustomerModalProcessing$ | async"
  [formsOfAddress]="customerFormsOfAddress$ | async"
  [isFormsOfAddressLoading]="customerFormsOfAddressLoading$ | async"
  [owners]="allUsers$ | async"
  [isOwnersLoading]="allUsersLoading$ | async"
  [initialOwnerId]="userId$ | async"
  (closeAction)="closeModal()"
  (customerDataChange)="createCustomer($event)"
></vpfa-customer-data-mobile>
